function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M29.422 10.951a.952.952 0 0 1 0-1.903H41.32a.952.952 0 0 1 0 1.903z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M43.37 10.673l-4.71 4.709a.951.951 0 1 1-1.345-1.346L41.35 10l-4.036-4.036a.952.952 0 0 1 1.345-1.346l4.71 4.71a.951.951 0 0 1 0 1.345z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#ffdd21",
  d: "M24.306 11.243a5.64 5.64 0 0 0-5.396 1.407c.44.22.827.418 1.141.613 1.442.894 1.713 2.4 1.343 3.498-.34 1.006-1.2 1.621-2.14 1.53a5.493 5.493 0 0 1-.896-.169 10.993 10.993 0 0 1-1.05-.35 5.641 5.641 0 1 0 6.998-6.53z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M18.075 9.35c1.269-.793 2.687-1.257 4.226-1.273-2.245-3.938-3.765-6.151-6.482-7.312C12.677-.577 3.612.222.501.081v9.032c1.5 1.112 3.222 4.213 4.963 4.955 3.379 1.44 6.462 1.25 8.103 1.69 1.641.44 2.978 1.235 4.508 1.383 1.529.149 2.478-2.302.331-3.633-2.147-1.331-8.202-3.499-6.44-6.557 1.153-2.004 4.035.33 6.109 2.4z"
})));

var SvgPayIcon = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 23,
    viewBox: "0 0 44 23",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPayIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pay_icon.98dd3331.svg";
export { ForwardRef as ReactComponent };